<template>
	<div>
		<pms-workerbench ref="pmsworkerbench"></pms-workerbench>
	</div>
</template>
<style>
	.el-dialog__footer {
		padding-top: 25px;
		padding-bottom: 10px;
		padding-right: 30px;
		text-align: right;
		box-sizing: border-box;
	}

	.el-dialog__header {
		padding: 0px 0px;
	}

	.el-tabs--top.el-tabs--card .el-tabs__item:last-child {
		padding: 0px 50px;
	}

	.el-tabs__item {
		padding: 0px 50px;
	}

	.el-dialog__body {
		padding: 0px 0px;
		color: #606266;
	}

</style>

<style lang="scss" scoped>
	.errorMessage {
		float: left;
		margin-left: 50px;
		font-size: 12px;
		color: #D0021B;
	}

	.radiogroup {
		margin-top: 5px;
		margin-bottom: 15px;
	}

	.radio {
		float: left;
		margin-top: 10px;
		margin-left: 10px;
	}

	.readyProjectDeclareText {
		font-size: 12px;
		float: left;
		color: #000000;
		text-align: left;
		margin-left: 50px;
		margin-right: 50px;
	}

	.bottomButton {
		height: 30px;
		width: 84px;
		display: inline-block;
		cursor: pointer;
		text-align: center;
		box-sizing: border-box;
		transition: 0.1s;
		font-weight: 500;
		border-radius: 2px;
		padding-top: 5px;
		font-size: 14px;
		margin-left: 15px;
	}

	.bottomButtonCancel {
		color: #606266;
		background: #fff;
		border: 1px solid #dcdfe6;
	}

	.bottomButtonConfirm {
		background: #1890ff;
		color: #ffffff;
	}

</style>
<script>
	import PMSWorkerbench from "./PMSWorkerbench";
	import config from "@/js/utils/config";
	import CONSTANTS from "@/js/utils/constants";
	import {
		Loading
	} from "element-ui";
	export default {
		name: "Workerbench",
		components: {
			"pms-workerbench": PMSWorkerbench
		},
		watch: {
			createProjectOperation: function (val) {
				if (val === "newProject") {
					this.errormessage = "";
					this.queryDisabled = true;
				} else {
					if (this.dialogVisible) {
						if (!this.queryprojectId) {
							this.errormessage = "*请选择要复制创建的项目";
						}
					}
					this.queryDisabled = false;
				}
			},
			queryprojectId: function (val) {
				if (this.dialogVisible) { //只有当弹框展示的时候校验queryid
					if (this.queryprojectId) {
						this.errormessage = "";
					} else {
						this.errormessage = "*请选择要复制创建的项目";
					}
				}
			},
		},
		data() {
			return {
                noDataText:"加载中...",
				errormessage: "",
				projectType: "formalProject", //formalProject:正式项目 readyProject:预立项项目
				readyProjectDeclareText: "预立项意指项目未确定是否立项或者尚未确定具体采集需求，提前告知项目组有一个可能的需求即将到来，请考虑预留资源支持。如果已经明确需要立项和具体采集需求，建议创建正式项目。",
				queryDisabled: true,
				queryprojectId: null,
				queryProjectIds: [],
				createProjectOperation: "",
				dialogVisible: false,
				currentWorkerbench: 'pms' //ds:需求方 pms:项目经理方
			};
		},

		created() {
		},

		mounted() {
			//TODO:上报页面数据
			this.loadProjects();
		},

		methods: {

			loadProjects() {
				var refworkerbench = null;
				if (this.currentWorkerbench === "ds") {
					refworkerbench = this.$refs.dsworkerbench;
				} else {
					refworkerbench = this.$refs.pmsworkerbench;
				}
				if (refworkerbench) {
					refworkerbench.loadProjects();
				}
			},

			queryProject(query) {
				if (query !== "") {
                    this.noDataText = "加载中...";
					var operation = 1;
					let userinfo = JSON.parse(localStorage.getItem("userinfo"));
					if (userinfo.role != CONSTANTS.USER_ROLE.PM) {
						operation = 0;
					}
					var that = this;
					let url = config.api.jobs;
					let params = {
						operation: operation,
						page: 1,
						per_page: 100,
						job_uid: query,
						title: query,
						over: 0,
						ride: 0
					};
					this.HttpUtils.get(url, params)
						.then(result => {
							if (result.data.items.length != 0) {
								that.queryProjectIds = [];
								result.data.items.forEach(element => {
									let label = element.job_uid + "-" + element.title;
									let value = element.id;
									that.queryProjectIds.push({
										label: label,
										value: value
									});
								});
							} else {
                                that.noDataText = "无数据";
								that.queryProjectIds = [];
							}
						})
						.catch(execption => {
                            console.log(execption);
                            that.noDataText = "无数据";
							that.queryProjectIds = [];
						});
				} else {
                    this.noDataText = "无数据";
					this.queryProjectIds = [];
				}
			}
		}
	};

</script>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_history_list/Workerbench.vue